<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close"
                  @click="$emit('close')"
                  aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{ isForCancelBill ? 'Cancelar' : 'Ignorar' }} Mensalidade
          </h4>
        </div>

        <div v-if="canBeIgnored" class="modal-body">
          <div class="modal-body__field">
            <label class="modal-body__field-label">Motivo</label>
            <select @click="errorMessage = null" v-model="ignoredReasonKey" class="form-control">
              <option v-for="(ignoredKey, index) in Object.keys(ignoredReasons)" :value="ignoredKey" :key="index">
                {{ ignoredReasons[ignoredKey].label }}
              </option>
            </select>
          </div>

          <div class="modal-body__field">
            <label class="modal-body__field-label">Outras informações</label>
            <input @click="errorMessage = null" class="form-control" type="text" v-model="observations">
          </div>

          <div v-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>
        </div>

        <div v-else class="modal-body">
          <div class="alert alert-danger">
            <p>
              Não é possível ignorar uma mensalidade que possui valor pago
            </p>
          </div>
        </div>

        <div class="modal-footer">
          <button v-if="canBeIgnored" class="btn btn-primary" @click="submit()">
            {{ isForCancelBill ? 'Cancelar' : 'Ignorar' }}
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BillsService from 'services/BillsService';

export default {
  data() {
    return {
      errorMessage: null,
      observations: null,
      ignoredReasonKey: null,
      ignoredReasons: {},
    };
  },
  mounted() {
    this.loadIgnoredReasons();
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
    canBeIgnored() {
      return this.selectedBill.ignorable;
    },
    isForCancelBill() {
      return this.ignoredReasonKey === 'canceled';
    },
    hasValidFields() {
      return this.observations && Object.keys(this.ignoredReasons).includes(this.ignoredReasonKey);
    },
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    loadIgnoredReasons() {
      BillsService.getIgnoredReasons()
        .then((body) => { this.ignoredReasons = this.addCanceledOption(body); })
        .catch(() => {
          this.errorMessage = 'Não foi possível carregar os motivos';
        });
    },
    submit() {
      if (this.hasValidFields && this.isForCancelBill) {
        this.cancelBill();
      } else if (this.hasValidFields) {
        this.ignoreBill();
      } else {
        this.errorMessage = 'Preencha todos os campos';
      }
    },
    cancelBill() {
      this.processRequest(
        BillsService.cancelBill(this.selectedBill.id, this.observations),
        'A mensalidade foi cancelada',
        'Erro ao cancelar mensalidade',
      );
    },
    ignoreBill() {
      this.processRequest(
        BillsService.ignoreBill(this.selectedBill.id, this.observations, this.ignoredReasonKey),
        'A mensalidade foi ignorada',
        'Erro ao ignorar mensalidade',
      );
    },
    processRequest(request, successMessage, errorPrefixMessage) {
      this.$loader.show();

      request
        .then(() => {
          this.loadStudentBills();
          this.$emit('close');
          this.$alert.notifySuccess(successMessage);
        })
        .catch(({ body }) => {
          this.$emit('close');
          this.$alert.notifyAlert(`${errorPrefixMessage}: ${body.message}`);
        })
        .finally(() => this.$loader.hide());
    },
    addCanceledOption(options) {
      const canceled = { id: 0, label: 'Cancelamento' };
      return Object.assign(options, { canceled });
    },
  },
};
</script>

<style lang="scss">
  .modal-body__field {
    margin: 8px;
  }

  .modal-body__field-label {
    font-weight: 600;
  }
</style>
